import React from "react";
import { Divider, Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField, { CFieldInputProps } from "$forms/CField";
import EntrepotActivities from "$forms/EntrepotActivities/EntrepotActivities";
import { entrepotActivities } from "$utils/typeConstants";
import useJStyles from "$hooks/useJStyles";

export const EntrepotFormActivities: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { jclasses } = useJStyles();

  return (
    <>
      <Box my={0.25}>
        <Divider />
      </Box>

      <div className={jclasses.formSectionHead}>
        <Text type="h3">Activité(s)*</Text>
      </div>
      <CField
        control={control}
        name="activities"
        error={errors.activities}
        rules={{
          validate: (activitieValues) => {
            return (
              activitieValues.some((v) =>
                entrepotActivities
                  .filter((a) => a.isAMainActivity)
                  .map((a) => a.value)
                  .includes(v)
              ) || "Au moins une activité principale est requise."
            );
          },
        }}
      >
        {(props: CFieldInputProps) => (
          // TODO : wording -> value
          <EntrepotActivities values={props.value} {...props} />
        )}
      </CField>

      <Box mb={0.5}>
        <Divider />
      </Box>
    </>
  );
};
